import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { ITab } from '../tabs';

export const TabListItem: React.FC<ITab> = ({
  label,
  children,
  selected,
  color,
  borderPlacement = 'bottom',
}) => (
  <div
    className='flex flex-col justify-center w-full h-full font-medium text-sm cursor-pointer'
    aria-current={selected ? 'page' : undefined}>
    {borderPlacement === 'top' && (
      <div className='relative w-full h-0'>
        <div
          className={`opacity-0 h-1 w-full transform ${
            selected && 'opacity-100'
          } top-0 left-0 absolute bg-${
            color?.classname
          } transition duration-500 ease-in-out h-1`}
        />
      </div>
    )}

    <div className='h-full px-1 flex justify-center items-center'>
      {label ? <Label {...label} /> : children}
    </div>
    {borderPlacement === 'bottom' && (
      <div className='relative w-full h-0'>
        <div
          className={`opacity-0 h-1 w-full transform translate-y-1 ${
            selected && 'opacity-100 -translate-y-0'
          } bottom-0 left-0 absolute bg-${
            color?.classname
          } transition duration-500 ease-in-out h-1`}
        />
      </div>
    )}
  </div>
);
